import ProductOverlay from '@components/Product/Overlay';
import SpinViewer from '@components/360Spin/_SpinViewer';
import SpinDialog from '@components/360Spin/_SpinDialog';
import SpinIndicator from '@components/360Spin/_SpinIndicator';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { classNames } from '@repo/ui/src/utils/classNames';
import { MediaType } from '@repo/ui/src/types/image';
import Product from '@models/product';

interface Props {
  product: Product;
  dark?: boolean;
  productList: any;
  display: boolean;
  encodedSpinSetUrl: string;
  images: Array<MediaType>;
}

const SpinSetWrapper = ({
  product: p,
  productList,
  display,
  encodedSpinSetUrl,
  images,
  dark,
}: Props) => {
  const [spinSetCount, setSpinSetCount] = useState(0);
  const [spinDialogOpen, setSpinDialogOpen] = useState(false);

  useEffect(() => {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    const fetchMetadata = async () => {
      try {
        const res = await axios.get(`${encodedSpinSetUrl}.json`, {
          cancelToken: source.token,
        });
        if (res?.data?.items?.length) {
          setSpinSetCount(res.data.items.length);
        }
      } catch {
        // Do nothing - just don't show the spin set
      }
    };
    fetchMetadata();
    return () => {
      source.cancel();
    };
  }, [encodedSpinSetUrl]);

  return (
    <div className="tw-relative tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center-tw-justify-center">
      <div className="overlay tw-absolute tw-top-0 tw-left-0 tw-grid-row-start-1 tw-grid-col-start-1 tw-flex tw-justify-center tw-items-center tw-h-full tw-w-full">
        <ProductOverlay
          product={p}
          images={productList}
          aspectWidth={1}
          aspectHeight={1}
          imageWidth={1000}
          display={display}
        />
      </div>
      {images?.length && (
        <>
          <div
            className={classNames(
              'spin-wrapper tw-grid-row-start-1 tw-grid-col-start-1 tw-h-full tw-relative tw-z-20 tw-transition-opacity tw-duration-300 tw-transition-linear [&_img]:tw-object-contain [&_img]:tw-h-full [&_img]:tw-p-10',
              display ? 'tw-opacity-0' : 'tw-opacity-1',
            )}
          >
            <SpinViewer
              url={encodedSpinSetUrl}
              count={spinSetCount}
              ariaLabel={p.title}
              disableMobilePointerEvents
            >
              <div className="tw-grid tw-grid-flow-col tw-items-center tw-justify-center tw-gap-6 tw-z-20">
                <SpinIndicator dark={dark} onClick={() => setSpinDialogOpen(true)} />
              </div>
            </SpinViewer>
          </div>
          <SpinDialog
            open={spinDialogOpen}
            onClose={() => setSpinDialogOpen(false)}
            url={encodedSpinSetUrl}
            spinSetCount={spinSetCount}
            ariaLabel={p.title}
          />
        </>
      )}
    </div>
  );
};

export default SpinSetWrapper;
